import { render, staticRenderFns } from "./productListImg.vue?vue&type=template&id=6096a169&scoped=true"
import script from "./productListImg.vue?vue&type=script&lang=js"
export * from "./productListImg.vue?vue&type=script&lang=js"
import style0 from "./productListImg.vue?vue&type=style&index=0&id=6096a169&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096a169",
  null
  
)

export default component.exports